'use client';

import {useCallback} from 'react';
import {useCookie} from './cookie.hooks';
import {useIsMac} from './userAgent.hooks';
import {emitEvent} from '@/lib/utils/analytics';
import {useMediaQuery} from './browser.hooks';
import {isBrowser} from '@/lib/utils/page.utils';

/**
 * Handles downloading the launcher installer for the correct platform; doesn't download on mobile
 */
export const useDownloadLauncher = (windowsUrl: string, macUrl: string): (() => void) => {
	const isMac = useIsMac();
	const isMobile = useMediaQuery('sm');
	const epicSid = useCookie('_epicSID');

	const initiateDownload = useCallback(() => {
		if (isBrowser() && !isMobile) {
			const link = document.createElement('a');
			const url = new URL(isMac ? macUrl : windowsUrl);
			if (epicSid) url.searchParams.append('trackingId', epicSid);
			const urlString = url.toString();
			link.href = urlString;
			link.setAttribute('download', '');
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			emitEvent({
				eventCategory: 'trigger',
				interactionType: 'click',
				eventAction: 'navigation',
				eventLabel: 'trigger-launcher-download',
				eventValue: {
					component: 'DownloadLauncher',
					urlString
				}
			});
		}
	}, [epicSid, isMac, isMobile, macUrl, windowsUrl]);

	return initiateDownload;
};
